import request from "@/api/request";
import { Landing } from "@/interfaces/Landing";

class LandingService {
  static async getLandingPage(props: { id?: number; lang?: string }): Promise<Landing> {
    return await request.get(`/landings/${props.id ? props.id : ""}`, { lang: props.lang });
  }
}

export default LandingService;
